import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=7ef75cfa&"
import script from "@/components/BarChart/BarChart.ts?vue&type=script&lang=ts&"
export * from "@/components/BarChart/BarChart.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports